import { render, staticRenderFns } from "./StadiumChatRoom.vue?vue&type=template&id=079f8a0a&"
import script from "./StadiumChatRoom.vue?vue&type=script&lang=js&"
export * from "./StadiumChatRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports